import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const getPopupAnalytics = {
  name: "getPopupAnalytics" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    /**
     * One row per popup with activity in the range. Rates are derived by the
     * client from these counts, so the two cannot disagree.
     */
    rows: z.array(
      z.object({
        /** A plain string: the logs outlive any given `FeatureOnboardingType`. */
        popupType: z.string(),
        shown: z.number(),
        ctaClicked: z.number(),
        dismissed: z.number(),
        retired: z.boolean(),
      }),
    ),
  }),
};
